import axios from 'axios'
import {RecuperarModel, RecuperarModelId} from '../../auth'
import {
  BancoMonedasModel,
  DatosComboMonedaModel,
  DatosCombosModel,
  DatosTipoDestinatarioModel,
  DatoscuentabModel,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL2
const API_URL2 = process.env.REACT_APP_API_URL2

export const DIRECCIONNOMBRE_URL = `${API_URL2}/Usuarios_Direcciones/GetDireccionNombre`
export const LLENARCOMBOS_URL = `${API_URL2}/Usuarios/Read_All`
export const LLENARCOMBOMONEDAS_URL = `${API_URL2}/Cat_Monedas/Monedas_Read_All`
export const GETBOMONEDASCTASBAN_URL = `${API_URL2}/cat_Prod_Financ_Banco/monedas`
export const USERUPDATE_URL = `${API_URL2}/Usuarios/Usuario_Update`

export const GETCUENTASBANCARIAS_URL = `${API_URL2}/CtasBancarias_OrigDest/ByUsuario`

export const GETCUENTASBANCARIASWIZARD_URL = `${API_URL2}/CtasBancarias_OrigDest/UnicasByUsuario`
export const CREATECUENTABANCARIA_URL = `${API_URL2}/CtasBancarias_OrigDest/Create`
export const UPDATECUENTABANCARIA_URL = `${API_URL2}/CtasBancarias_OrigDest/Update`
export const DELETECUENTABANCARIA_URL = `${API_URL2}/CtasBancarias_OrigDest/Delete`

export const INVITARUSUARIO_URL = `${API_URL2}/Autenticacion/InviteUser`
export const ACTUALIZARNOTIFICACIONES_URL = `${API_URL2}/Usuarios/Notificaciones_Update`
export const GETTIPOSDESTINATARIOS_URL = `${API_URL2}/Destinatario_Tipo/Activos`

export function actualizarUsuario(
  idusuario: number | undefined,
  apellido_paterno: string | undefined,
  apellido_materno: string | undefined,
  nombre1: string | undefined,
  nombre2: string | undefined,
  email: string,
  password: string,
  id_tipo_persona: number,
  fecha_nacimiento: string | undefined,
  id_sexo: number | undefined,
  id_estado_civil: number | undefined,
  id_estatus: string | undefined,
  id_pais_localizacion: string,
  rol: string,
  app: string
) {
  return axios.post<RecuperarModel>(`${USERUPDATE_URL}?idUsuario=${idusuario}`, {
    idusuario,
    apellido_paterno,
    apellido_materno,
    nombre1,
    nombre2,
    email,
    password,
    id_tipo_persona,
    fecha_nacimiento,
    id_sexo,
    id_estado_civil,
    id_estatus,
    id_pais_localizacion,
    rol,
    app,
  })
}

export function localizacionPorCodigo(pais: string | undefined, codigo: number) {
  return axios.get<string>(`${DIRECCIONNOMBRE_URL}?pais=${pais}&codigo=${codigo}`)
}

export function llenarCombosUsuario(
  cantidad_max: string,
  language: string,
  campo: string,
  operador: string,
  valor1: string,
  valor2: string,
  tipo: string
) {
  return axios.post<DatosCombosModel>(LLENARCOMBOS_URL, {
    cantidad_max,
    language,
    filters: [
      {
        campo,
        operador,
        valor1,
        valor2,
        tipo,
      },
    ],
  })
}

export function llenarComboMoneda(
  cantidad_max: string,
  language: string,
  campo: string,
  operador: string,
  valor1: string,
  valor2: string,
  tipo: string
) {
  return axios.post<DatosComboMonedaModel>(LLENARCOMBOMONEDAS_URL, {
    cantidad_max,
    language,
    filters: [
      {
        campo,
        operador,
        valor1,
        valor2,
        tipo,
      },
    ],
  })
}

export function getMonedasCtasBan(id_tipo_prod_financ: number, idBanco: number) {
  return axios.post<BancoMonedasModel>(GETBOMONEDASCTASBAN_URL, {
    id_tipo_prod_financ,
    idBanco,
  })
}

export function getCuentasBancarias(id: number, lang: string) {
  return axios.post<DatoscuentabModel>(GETCUENTASBANCARIAS_URL, {
    id,
    lang,
  })
}

export function createCuentaBancaria(
  idusuario: number | undefined,
  id_prod_financieros: number,
  cci: string | null,
  nro_Cta: string | null,
  titular_Cta: string | null,
  lang: string,
  celular_destinatario: string | null,
  correo_destinatario: string | null,
  iban: string | null,
  clabe: string | null,
  cedula: string | null,
  id_tipo_destinatario: number | null,
  tipoDocumento: number | null,
  nroDocumento: string | null,
  nacionalidadBenef: string | null,
  cod_Envio: string | null,
  nro_Tarjeta: string | null
) {
  return axios.post<RecuperarModelId>(CREATECUENTABANCARIA_URL, {
    idusuario,
    id_prod_financieros,
    cci,
    nro_Cta,
    titular_Cta,
    lang,
    celular_destinatario,
    correo_destinatario,
    iban,
    clabe,
    cedula,
    id_tipo_destinatario,
    tipoDocumento,
    nroDocumento,
    nacionalidadBenef,
    cod_Envio,
    nro_Tarjeta,
  })
}

export function updateCuentaBancaria(
  id_cb: number,
  idusuario: number | undefined,
  // idBanco: number,
  cci: string | null,
  nro_Cta: string | null,
  titular_Cta: string | null,
  lang: string,
  celular_destinatario: string | null,
  correo_destinatario: string | null,
  iban: string | null,
  clabe: string | null,
  cedula: string | null,
  id_tipo_destinatario: number | null,
  tipoDocumento: number | null,
  nroDocumento: string | null,
  nacionalidadBenef: string | null,
  id_prod_financieros: number,
  cod_Envio: string | null,
  nro_Tarjeta: string | null
) {
  return axios.post<RecuperarModel>(`${UPDATECUENTABANCARIA_URL}?id=${id_cb}`, {
    idusuario,
    // idBanco,
    cci,
    nro_Cta,
    titular_Cta,
    lang,
    celular_destinatario,
    correo_destinatario,
    iban,
    clabe,
    cedula,
    id_tipo_destinatario,
    tipoDocumento,
    nroDocumento,
    nacionalidadBenef,
    id_prod_financieros,
    cod_Envio,
    nro_Tarjeta,
  })
}

export function deleteCuentaBancaria(id_cb: number, lang: string) {
  return axios.post<RecuperarModel>(DELETECUENTABANCARIA_URL, {
    id_cb,
    lang,
  })
}
export function InvitarUser(
  idUsuario: number | undefined,
  email: string,
  nombre: string,
  apellido: string,
  language: string
) {
  return axios.post<RecuperarModel>(INVITARUSUARIO_URL, {
    idUsuario,
    email,
    nombre,
    apellido,
    language,
  })
}

export function UpdateNotifications(
  idUsuario: number | undefined,
  allow_marketing: boolean | undefined,
  newletter_por_mail: boolean | undefined,
  newletter_por_wapp: boolean | undefined,
  facturacion_por_mail: boolean | undefined,
  facturacion_por_wapp: boolean | undefined
) {
  return axios.post<RecuperarModel>(`${ACTUALIZARNOTIFICACIONES_URL}?idUsuario=${idUsuario}`, {
    allow_marketing,
    newletter_por_mail,
    newletter_por_wapp,
    facturacion_por_mail,
    facturacion_por_wapp,
  })
}

export function getTiposDestinatarios() {
  return axios.post<DatosTipoDestinatarioModel>(GETTIPOSDESTINATARIOS_URL)
}
